import {Injectable, Injector} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { factory } from '../shared/app-logging';

const logger = factory.getLogger('AuthService');

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private enoc_session!: string | any;
  private default_brand!: string | any;
  private locale!: string | any;
  private user_name!: string | any;
  private isAuth!: string | any;

  private cookieService: CookieService;
  private httpClient: HttpClient;

  constructor(private injector: Injector) {
    this.cookieService = this.injector.get(CookieService);
    this.httpClient = this.injector.get(HttpClient);
  }

  // public checkAuthorization(): Observable<boolean> {
  //   if (this.isAuth) {
  //     return of(this.isAuth);
  //   }
  //   const _self = this;
  //   return this.httpClient.get(environment.contentLibraryApiBaseUrl + AppConfig.urlPing).pipe(map(
  //     (response: HttpResponse<any>) => {
  //       logger.debug(`Got response: ${JSON.stringify(response)}`);
  //       if (response && response.status >= 200 && response.status < 300) {
  //         _self.isAuth = true;
  //         return true;
  //       }
  //       return false;
  //     }
  //   ), catchError((err: Error | HttpErrorResponse) => {
  //     const message = `In AuthService.checkAuthorization().`;
  //     return throwError(ErrorDataService.overLoadError(err, message));
  //   }));
  // }

  logIn(enoc_session: string, default_brand: string, locale: string, user_name: string) {
    this.enoc_session = enoc_session;
    this.default_brand = default_brand;
    this.locale = locale;
    this.user_name = user_name;
  }

  logout() {
    this.enoc_session = null;
    this.default_brand = null;
    this.locale = null;
    this.user_name = null;
    this.cookieService.deleteAll('/', environment.openAmCookieDomain);
  }

  isLoggedIn(): boolean {
    return this.enoc_session && this.enoc_session.length > 0;
  }

  getToken() {
    return this.enoc_session;
  }

  getUserName() {
    return this.user_name;
  }

  // takeLoginDetailsFromCookie() {
  //   if (this.cookieService.check(AppConfig.sessionTokenVariableName)) {
  //     const enoc_session = this.cookieService.get(AppConfig.sessionTokenVariableName);
  //     const user_name = this.cookieService.get(AppConfig.sessionUsernameVariableName);
  //     const locale = this.cookieService.get('locale');
  //     const default_brand = this.cookieService.get('default_brand');
  //     this.logIn(enoc_session, default_brand, locale, user_name);
  //   }
  // }

}
